import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { FeaturedDepartments } from '../components/home/FeaturedDepartments';
import { SocialProofBar } from '../components/home/SocialProofBar';
import { FeaturedProducts } from '../components/home/FeaturedProducts';
import { SpecialsSection } from '../components/home/SpecialsSection';
import { LatestCatalogue } from '../components/home/LatestCatalogue';
import { TrustedBrands } from '../components/home/TrustedBrands';
import { CustomerTestimonials } from '../components/home/CustomerTestimonials';
import { WhyShopSection } from '../components/home/WhyShopSection';
import { CustomerCareClub } from '../components/home/CustomerCareClub';
import { StoreLocator } from '../components/home/StoreLocator';
import { ExpertAdvice } from '../components/home/ExpertAdvice';
import { FAQSection } from '../components/home/FAQSection';
interface HomePageProps {
  onNavigate: (page: 'shop' | 'product') => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  return <main className="bg-white" data-id="element-638">
      {/* 1. Hero carousel */}
      <HeroSection onNavigate={onNavigate} data-id="element-639" />

      {/* 2. Category Tiles — visual grid */}
      <FeaturedDepartments onNavigate={onNavigate} data-id="element-640" />

      {/* 3. Trust Signals — thin strip with Price Match */}
      <SocialProofBar data-id="element-641" />

      {/* 4. Discover — popular products with quick-add */}
      <FeaturedProducts onNavigate={onNavigate} data-id="element-642" />

      {/* 5. Urgency — this week's specials */}
      <SpecialsSection data-id="element-643" />

      {/* 6. Objection Handling — why shop with us */}
      <WhyShopSection data-id="element-644" />

      {/* 7. Social Proof — customer testimonials */}
      <CustomerTestimonials data-id="element-645" />

      {/* 8. Conversion Checkpoint — Customer Care Club */}
      <CustomerCareClub data-id="element-646" />

      {/* 9. Authority — brand logos */}
      <TrustedBrands data-id="element-647" />

      {/* 10. Engagement — latest catalogue */}
      <LatestCatalogue data-id="element-648" />

      {/* 11. Content/SEO — expert advice */}
      <ExpertAdvice data-id="element-649" />

      {/* 12. Local Intent — find your store */}
      <StoreLocator data-id="element-650" />

      {/* 13. Friction Reducer — FAQ */}
      <FAQSection data-id="element-651" />
    </main>;
}